import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from "react-router-dom";
import {
  IMAGES_ENDPOINT,
  STATE_LOOKUP,
  DEMOCRATIC,
	DEMOCRATIC_COLOR,
	REPUBLICAN,
	REPUBLICAN_COLOR,
  INDEPENDENT_COLOR
} from "../../common/Utils";

function getLeadershipPosition(member) {
  if (1 <= member.leadershipPositions.length ) {
    return member.leadershipPositions[0].title;
  } else {
    return member.positions[0].title;
  }
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F4F4F4",
    width: "100%",
    maxHeight: 350,
    borderRadius: 0
  },
  rootLink: {
    '&:hover': {
      textDecoration: 'none',
    }
  },
  media: {
    backgroundPosition: 'top',
    [theme.breakpoints.down('xs')]: {
      height: "100%"
    },
    [theme.breakpoints.up('sm')]: {
      height: 220
    },
  },
  fullNameText: {
		color: '#2F3B4B',
		fontFamily: 'Graphik',
		fontSize: 16,
    fontWeight: 600
  },
  positionText: {
    color: '#333333',
    fontFamily: 'Graphik',
		fontSize: 14
  },
  stateText: {
    color: '#333333',
    fontFamily: 'Graphik',
		fontSize: 14
  },
  colorBar:{
    height: 8,
    width: '100%'
  }
}));

export function getState(member) {
  let districCode, stateAbbreviation;

  if (member.positions !== undefined && member.positions.length > 0 && member.positions[0].stateDistrictCode !== undefined) {
    districCode = member.positions[0].stateDistrictCode;
    stateAbbreviation = districCode.split("-")[0];
    return STATE_LOOKUP[stateAbbreviation];
  } else if (member.positions !== undefined && member.positions.length > 1 && member.positions[1].stateDistrictCode !== undefined) {
    districCode = member.positions[1].stateDistrictCode;
    stateAbbreviation = districCode.split("-")[0];
    return STATE_LOOKUP[stateAbbreviation];
  }
}

export function getPartyColor(member) {
	switch (member.party.label) {
		case DEMOCRATIC:
			return DEMOCRATIC_COLOR;
		case REPUBLICAN:
			return REPUBLICAN_COLOR;
		default:
			return INDEPENDENT_COLOR;
	}
}

const MemberCard = ( member ) => {
  const {
    personId,
    fullName,
    party : { abbreviation },
    positionDetails = { numberTerms: "" }
   } = member;
  const classes = useStyles();
  const numberTerms = positionDetails.numberTerms;
  return (
    <Card id="landingPageMemberCard" className={classes.root}>
      <div className={classes.colorBar} style={{backgroundColor: getPartyColor(member)}}/>
      <CardActionArea className={classes.rootLink} component={Link} to={"/members/".concat(personId)}>
        <Grid container spacing={0}>
          <Grid item xs={5} sm={12}>
            <CardMedia
              className={classes.media}
              image={IMAGES_ENDPOINT.concat(personId,"/image/medium")}
              title={member.fullName}
            />
          </Grid>
          <Grid item xs={7} sm={12}>
            <CardContent>
              <Typography className={classes.fullNameText} gutterBottom>
                {fullName}
              </Typography>
              <Typography className={classes.positionText} gutterBottom>
                {getLeadershipPosition(member)}
              </Typography>
              <Typography className={classes.stateText} gutterBottom>
                {getState(member)}
              </Typography>
              <Typography style={{color: getPartyColor(member)}} gutterBottom>
                {abbreviation} - {numberTerms}
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  );
};


MemberCard.propTypes = {
  fullName: PropTypes.string.isRequired
};

export default MemberCard;
